import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { IS_PRODUCTION } from '@rma/public/generic/util/environment';
import { installTrackJS } from '@rma/public/generic/util/tracking/track-js';
import { RmaLayoutComponent } from '@rma/public/site/public/orc-layout';
import { RecaptchaComponent } from 'ng-recaptcha';
import { config } from './app/app.config.browser';

if (IS_PRODUCTION) {
  enableProdMode();
  installTrackJS('public-ui');
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => bootstrapApplication(RmaLayoutComponent, config).catch((err) => console.error(err)));
});

RecaptchaComponent.prototype.ngOnDestroy = function () {
  if (this.subscription) {
    this.subscription.unsubscribe();
  }
};
